import { render } from "./batch_details.vue?vue&type=template&id=591e7eb4"
import script from "./batch_details.vue?vue&type=script&lang=js"
export * from "./batch_details.vue?vue&type=script&lang=js"

import "./batch_details.vue?vue&type=style&index=0&id=591e7eb4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__